import { TOUR_TRANSLATIONS } from "../translations"

export const getProductPageImageDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="pp-image-details-filters"]',
            title: t.ppImageDetailsFilters.title,
            content: t.ppImageDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="pp-image-details-table"]',
            title: t.ppImageDetailsTable.title,
            content: t.ppImageDetailsTable.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.ppImageDetailsGallery.title,
            content: t.ppImageDetailsGallery.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'pp-image-details-table', closeOnLeave: true },
        },
    ]
}
